import { encryptStorage } from '@/utils/storage';

export const AUTH_USER_INFO = (state, userInfo) => {
  state.userInfo = userInfo;
  if (userInfo.Token) {
    encryptStorage.setItem("token", userInfo.Token);
    encryptStorage.setItem("user", JSON.stringify(userInfo));
  }
};
export const AUTH_SIPMOVIL_USER_INFO = (state, userInfoSipmovil) => {
  state.userInfoSipmovil = userInfoSipmovil;

  if (userInfoSipmovil.token) {
    encryptStorage.setItem("token", userInfoSipmovil.token);
    encryptStorage.setItem("user", JSON.stringify(userInfoSipmovil));
  }
};

export const AUTH_COMPANY_INFO = (state, companyInfo) => {
  state.companyInfo = companyInfo;
  if (companyInfo) {
    encryptStorage.setItem('company', JSON.stringify(companyInfo));
  }
};

export const SET_AUDIOS_SOURCE = (state, userInfoSipmovil) => {
  state.transfer_audio = userInfoSipmovil.transferAudio;
  state.new_message_audio = userInfoSipmovil.newMessageAudio;
  const audioElementTransfer = document.getElementById("sip-audio-transfer");
  const audioElementMessage = document.getElementById("sip-audio-message");
  if (audioElementTransfer && userInfoSipmovil.transferAudio) {
    audioElementTransfer.src = userInfoSipmovil.transferAudio;
    audioElementTransfer.load();
  }
  if (audioElementMessage && userInfoSipmovil.newMessageAudio) {
    audioElementMessage.src = userInfoSipmovil.newMessageAudio;
    audioElementMessage.load();
  }
};

export const CHANGE_AVATAR = (state, value) => {
  state.userInfo.Avatar = value;
  encryptStorage.setItem('user', JSON.stringify(state.userInfo));
};

export const UPDATE_COMPANY = (state, value) => {
  state.userInfo.PbxServer = value;
};

export const UPDATE_VOICE_AGENT_URL = (state, value) => {
  state.userInfo.VoiceAgentUrl = value;
};

export const SET_PINNED_CHATS = (state, pinnedChats) => {
  state.userInfo.pinnedChats = pinnedChats;
  encryptStorage.setItem('user', JSON.stringify(state.userInfo));
};

export const SET_TWO_FACTOR_ENABLED = (state, value) => {
  state.userInfo.twoFactorEnabled = value;
  encryptStorage.setItem('user', JSON.stringify(state.userInfo));
};

export const SET_CRM_CHAT_ENABLED = (state, value) => {
  state.userInfo.crm_chat_enabled = value;
  encryptStorage.setItem('user', JSON.stringify(state.userInfo));
};

export const TOGGLE_AUDIO_SIPMOVIL = (state, value) => {
  state.userInfo.audioSipmovil = value;
  encryptStorage.setItem("user", JSON.stringify(state.userInfo));
};

export const TOGGLE_AUDIO_JOIN = (state, value) => {
  state.userInfo.audioJoin = value;
  encryptStorage.setItem("user", JSON.stringify(state.userInfo));
};

// task_notas_voz: guarda la velocidad de reproducción de notas de voz (1 | 1.5 | 2)
// en userInfo y la persiste (para que los audios nuevos abran a la última velocidad,
// incluso tras recargar). Mismo patrón que TOGGLE_AUDIO_SIPMOVIL.
export const SET_PLAYBACK_RATE = (state, value) => {
  state.userInfo.playbackRate = value;
  encryptStorage.setItem("user", JSON.stringify(state.userInfo));
};
// export const LOGOUT_SIPMOVIL_USER = (state)=>{
//     state.userInfoSipmovil = ""
//     encryptStorage.removeItem('token')
// }
